document.addEventListener("DOMContentLoaded", () => {
  const bar = document.querySelector("[data-dd-sticky-atc]");
  if (!bar) return;

  const productForm = document.querySelector('form[action^="/cart/add"]');
  const atcButton = productForm?.querySelector('button[type="submit"], input[type="submit"]');
  if (!productForm || !atcButton) return;

  const barBtn = bar.querySelector("[data-dd-sticky-atc-btn]");

  const io = new IntersectionObserver(([entry]) => {
    bar.hidden = false;
    bar.classList.toggle("is-visible", !entry.isIntersecting);
  }, { threshold: 0 });

  io.observe(atcButton);

  barBtn.addEventListener("click", () => atcButton.click());
});